// @flow

export function isVoucher(paymentMethodCode: string): boolean {
  return VOUCHER_PAYMENT_METHOD_CODES.includes(paymentMethodCode);
}

const VOUCHER_PAYMENT_METHOD_CODES = [
  'boleto',
  'cash',
  'eft',
  'multicaja',
  'nequi',
  'oxxo',
  'oxxopay',
  'pagoefectivo',
  'safetypay-cash',
  'safetypay-online',
  'safetypay',
  'sencillito',
  'servipag',
  'spei',
  'tef',
  'webpay',
];
